import {Component, Inject, Mixins, Watch} from "vue-property-decorator";
import {UsersRolesSummary} from "~/modules/users/compponents/roles-summary";
import {TextFilter} from "~/components/text-filter";
import {Columns} from "~/components/grid/columns";
import {Column} from "~/components/grid/column";
import XSelect from "~/components/forms/x-select";
import {UsersTable} from "~/modules/users/compponents/users-table";
import {Modal} from "~/components/modal";
import {ScopesMatrix} from "~/components/scopes-matrix";
import {UsersRolesList} from "~/modules/users/compponents/roles-list";
import {ButtonMainCreate} from "~/components/buttons/button-main-create";
import {QuotasCheckMixin} from "~/components/quotas-mixin";
import {getUsersManagementStore} from "~/modules/users/store";
import {AppSettings} from "~/lib/app-settings";
import {UsersLoaderMixin} from "~/modules/users/lib/users-loader-mixin";
import {sort} from "~/lib/helpers";
import {Group} from "~/lib/models/group";
import {User} from "~/lib/models/user";
import {Role} from "~/modules/users/lib/roles-utils";

const usersManagementStore = getUsersManagementStore();

@Component
export class UsersList extends Mixins(UsersLoaderMixin, QuotasCheckMixin) {

  @Inject() appSettings: AppSettings;

  @usersManagementStore.Getter roles: Role[];
  @usersManagementStore.State users: User[];
  @usersManagementStore.State groups: Group[];
  @usersManagementStore.State rolesConfig;
  @usersManagementStore.State scopes;
  @usersManagementStore.Action fetchUsers;

  private showScopes = false;
  private showAllRoles = false;

  async created(){
    await this.loadUsers();
  }

  get sortedGroups() {
    return [
      ...sort(this.groups, (a, b) => {
        if (a.label?.toLowerCase() > b.label?.toLowerCase()) return 1;
        if (a.label?.toLowerCase() < b.label?.toLowerCase()) return -1;
        return 0;
      }),
      {id: -1, label: "Sans groupe"}
    ];
  }

  async checkAdduserQuotas() {
    if (await this.checkMaxUsersQuota()) {
      this.$router.push({name: "users-edit", params: {uuid: "new"}});
    }
  }

  render() {
    return (
      <div>
        <UsersRolesSummary onShowScopes={() => this.showScopes = true}  onShowAllRoles={() => this.showAllRoles = true} />
        <Columns>
          <Column>
            <TextFilter v-model={this.textFilter} placeholder="Rechercher"  />
          </Column>
          <Column>
            <XSelect
              allowNull
              nullLabel="--- Rôles"
              value={this.rolesFilter}
              data={this.roles}
              label={r => r.label}
              equality={(r, v) => r?.id === v?.id}
              onInput={r => this.rolesFilter = r}
            />
          </Column>
          <Column>
            <XSelect
              allowNull
              nullLabel="--- Groupes"
              value={this.groupFilter}
              data={this.sortedGroups}
              label={grp => grp.label}
              equality={(r, v) => r?.id === v?.id}
              onInput={r => this.groupFilter = r}
              readonly={this.groups.length === 0}
            />
          </Column>
        </Columns>

        <UsersTable users={this.users} roles={this.roles}/>
        {this.renderPagination()}

        {this.showScopes && (
          <Modal class="scopes-matrix--modal" isActive showCloseButton onClose={() => this.showScopes = false}>
            <div class="box">
              <ScopesMatrix roles={this.roles} scopes={this.scopes}/>
            </div>
          </Modal>
        )}

        {this.showAllRoles && (
          <Modal class="roles-list-modal" isActive showCloseButton onClose={() => this.showAllRoles = false}>
            <div class="box">
              <UsersRolesList rolesConfig={this.rolesConfig} users={this.users}/>
            </div>
          </Modal>
        )}

        <ButtonMainCreate onClick={this.checkAdduserQuotas} dataTooltip="Créer un utilisateur" />
        {this.renderQuotasModal()}
      </div>
    );
  }
}


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-6f75af1c/users-list.tsx" });